import React, { useContext } from "react";
import { ItemLink, MarketLabel } from "./style";
import PropTypes from "prop-types";
import { LanguageContext } from "../../core/store";

const LastItem = ({ path, translateKey }) => {

    const { translate } = useContext(LanguageContext);

    let customLabel = translate(translateKey)?.split(" - "); // 1-ci textinden kaynaklı doğru split etmek için kenarlara boşluk eklendi.
    return (
        <ItemLink to={path}>
            {customLabel?.[0]}
            <MarketLabel>{customLabel?.[1]}</MarketLabel>
        </ItemLink>
    );
};

LastItem.propTypes = {
    path: PropTypes.string.isRequired,
    translateKey: PropTypes.string.isRequired
};

export default LastItem;
